module.exports = __webpack_public_path__ + "img/knife_gut.b20536e9.svg";